import { Link } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { useRouter } from '@cvt/routing';
import { useDictionary } from '@cvt/hooks/useDictionary';
import HeartPulse from '@modules/Tributes/components/HeartPulse';

import { Layout } from '../components/Layout/Layout';
import { Explainer } from '../partials/Explainer';
import { StepsOverview } from '../partials/StepsOverview';


export const StartHere = () => {
  const router = useRouter();
  const dictionary = useDictionary();

  return (
    <Layout>
      <Stack gap={2} alignItems="center">
        <HeartPulse />
        <Typography variant="h1" fontWeight={700} textTransform="uppercase">
          {dictionary.start.title}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          {dictionary.start.subtitle}
        </Typography>
      </Stack>
      <Explainer />
      <StepsOverview />
      <Stack gap={2} alignItems="center" mt={8}>
        <Button
          component={Link}
          to={router.tributes.create.details.path}
          variant="contained"
          size="large"
        >
          {dictionary.start.cta}
        </Button>
        <Typography variant="body2" color="textSecondary">
          {dictionary.start.ctaExplainer}
        </Typography>
      </Stack>
    </Layout>
  );
};
